import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../index';

export interface ClientProposalRow {
  id: number;
  uuid: string;
  passkey: string;
  client_name: string | null;
  client_email: string;
  shared_content: string; // JSON array string e.g. '["sow"]'
  view_count: number;
  client_status: 'pending' | 'approved' | 'changes_requested' | null;
  client_message: string | null;
  client_responded_at: string | null;
  project_id: number;
  project_name: string | null;
  project_uuid: string | null;
  scope_agreement_uuid: string | null;
  created_by_user_id: number | null;
  created_by_email: string | null;
  last_viewed_at: string | null;
  expires_at: string | null;
  created_at: string;
}

interface ListResponse {
  success: boolean;
  data: ClientProposalRow[];
  meta?: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

interface ListParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const clientProposalsApi = createApi({
  reducerPath: 'clientProposalsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/v1/admin/client-proposals',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['ClientProposals'],
  endpoints: (builder) => ({
    listClientProposals: builder.query<ListResponse, ListParams | void>({
      query: (params = {}) => ({
        url: '/',
        params: {
          page: params?.page ?? 1,
          limit: params?.limit ?? 50,
          search: params?.search ?? '',
        },
      }),
      providesTags: ['ClientProposals'],
    }),
  }),
});

export const { useListClientProposalsQuery } = clientProposalsApi;
